module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel202309_04_1280_1280_ja-045a5fddcb99d1f7e82254d48f9e4e9b.jpg";